export const CategoryInitialValues = {
    name: "",
    job: [],
   
  };